module.exports = __webpack_public_path__ + "33cf798c56148b448b156e26d7edf4e0.woff";